import type { ImageDetails } from "proto/image";

/**
 * Create a placeholder image URL.
 * @param text Any text to be displayed on the placeholder image.
 * @param width The width of the placeholder image.
 * @param height The height of the placeholder image.
 * @param bgColour The background colour of the placeholder image.
 * @param textColour The text colour of the placeholder image.
 * @returns a URL for a placeholder image.
 */
export function getPlaceHolderImgUrl(text = '', width = 200, height = 100, bgColour = '#ccc', textColour = '#333') {
	const s = encodeURIComponent(text);
	const bgc = encodeURIComponent(bgColour);
	const tc = encodeURIComponent(textColour);
	return `data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20width%3D'${width}'%20height%3D'${height}'%3E%3Crect%20width%3D'100%25'%20height%3D'100%25'%20fill%3D'${bgc}'%2F%3E%3Ctext%20x%3D'50%25'%20y%3D'50%25'%20font-family%3D'Arial'%20font-size%3D'20'%20fill%3D'${tc}'%20dy%3D'.3em'%20text-anchor%3D'middle'%3E${s}%3C%2Ftext%3E%3C%2Fsvg%3E`
}
export const TEST_PLACEHOLDER_IMAGE_URL = getPlaceHolderImgUrl('placeholder', 160, 90);

export function img(
	provider = 'thumbor',
	filename = "image.jpg",
	base_url = "https://dev.mrd.com",
	raw_image = "https://dev.mrd.com/image.jpg",
	properties = { size: 10000, width: 100, height: 100 },
	mime_type = "image/jpeg",
) {
	return {
		filename,
		provider,
		mime_type,
		base_url,
		raw_image,
		properties
	} as ImageDetails;
}

export function dimg() {
	const image = img('', '', '');
	image.raw_image = TEST_PLACEHOLDER_IMAGE_URL;
	return image;
}
